import { ISsConstant, SS_CONSTANT, SsConstant } from './ss.constant';

export { SS_CONSTANT, ISsConstant, SsConstant };
